import { IconLabel } from '../../../shared';

import classNames from 'classnames';
import classes from '../LeaderBoard.module.scss';

interface RenderIndexCellArgs {
  position: number;
  isActive: boolean;
  color?: string;
}

export const renderPositionCell = ({
  position,
  isActive,
  color = '#292E4B',
}: RenderIndexCellArgs) => {
  return (
    <td className={classNames({ [classes['leader-board__table-position--active']]: isActive })}>
      {position < 4 ? (
        <IconLabel
          iconId={`${position}-place`}
          iconSize={30}
          color={color}
          singleColor
          nonClickable
        />
      ) : (
        <span className={classes['leader-board__table-position']}>{position}</span>
      )}
    </td>
  );
};
